








import Vue from 'vue';

function pageOffset(el: Element) {
  // -> {x: number, y: number}
  // get the left and top offset of a dom block element
  const rect = el.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    y: rect.top + scrollTop,
    x: rect.left + scrollLeft,
  };
}
export default Vue.extend({
  props: ['imgNormal', 'imgZoom', 'scale', 'disabled'],
  data() {
    return {
      scaleFactor: 1,
      resizeCheckInterval: null as number | null,
      zoomed: false,
    };
  },
  methods: {
    touchzoom(event: MouseEvent) {
      if (this.disabled) return;
      this.move(event);
      this.zoomed = !this.zoomed;
    },
    zoom() {
      if (!this.disabled) this.zoomed = true;
    },
    unzoom() {
      if (!this.disabled) this.zoomed = false;
    },
    move(event: MouseEvent) {
      if (this.disabled || !this.zoomed) return;
      const offset = pageOffset(this.$el);
      const { zoom } = this.$refs;
      const { normal } = this.$refs;
      const relativeX = event.clientX - offset.x + window.pageXOffset;
      const relativeY = event.clientY - offset.y + window.pageYOffset;
      if (normal instanceof HTMLImageElement && zoom instanceof HTMLImageElement) {
        const normalFactorX = relativeX / normal.offsetWidth;
        const normalFactorY = relativeY / normal.offsetHeight;
        const x = normalFactorX * (zoom.offsetWidth * this.scaleFactor - normal.offsetWidth);
        const y = normalFactorY * (zoom.offsetHeight * this.scaleFactor - normal.offsetHeight);
        zoom.style.left = `${-x}px`;
        zoom.style.top = `${-y}px`;
      }
    },
    initEventLoaded() {
      // emit the "loaded" event if all images have been loaded
      const promises = [this.$refs.zoom, this.$refs.normal]
        .map(image => new Promise(((resolve, reject) => {
          if (image instanceof Element) {
            image.addEventListener('load', resolve);
            image.addEventListener('error', reject);
          }
        })));
      const component = this;
      Promise.all(promises).then(() => {
        component.$emit('loaded');
      });
    },
    initEventResized() {
      const { normal } = this.$refs;
      if (normal instanceof HTMLImageElement) {
        let previousWidth = normal.offsetWidth;
        let previousHeight = normal.offsetHeight;
        const component = this;
        this.resizeCheckInterval = setInterval(() => {
          if ((previousWidth !== normal.offsetWidth) || (previousHeight !== normal.offsetHeight)) {
            previousWidth = normal.offsetWidth;
            previousHeight = normal.offsetHeight;
            component.$emit('resized', {
              width: normal.width,
              height: normal.height,
              fullWidth: normal.naturalWidth,
              fullHeight: normal.naturalHeight,
            });
          }
        }, 1000);
      }
    },
  },
  mounted() {
    if (this.$props.scale) {
      this.scaleFactor = Number(this.$props.scale);
      if (this.$refs.zoom instanceof HTMLElement) {
        this.$refs.zoom.style.transform = `scale(${this.scaleFactor})`;
      }
    }
    this.initEventLoaded();
    this.initEventResized();
  },
  updated() {
    this.initEventLoaded();
  },
  beforeDestroy() {
    if (this.resizeCheckInterval) {
      clearInterval(this.resizeCheckInterval);
    }
  },
});
